import { createFileRoute } from '@tanstack/react-router';
import { DirectoryTab } from '@/features/integrations';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/directory')({
  component: withRumPageRendered(DirectoryTab),
});
